import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox-checked",
  "use": "checkbox-checked-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"checkbox-checked\"><path d=\"M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1.9 6.4l-6.4 6.4c-.1.1-.2.1-.4.1-.1 0-.3-.1-.4-.1L7.3 13c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l2.3 2.3 6-6c.2-.2.5-.2.7 0s.2.6.1.8z\" fill=\"#46a8f6\" /><path d=\"M0 0h24v24H0V0z\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol